import { observable } from "mobx";
import { Type } from "class-transformer";
import { Expose } from "class-transformer";
import ProductCardPreview from "./productCardPreview";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ProductCardPreviewList {
  @observable
  total!: number;

  @observable
  @Type(() => ProductCardPreview)
  @Expose({ name: "product_cards" })
  productCards!: ProductCardPreview[];

  static ValidationRules = {
    total: { required: true, number: true },
    productCards: { required: true },
  };
}
